export default __webpack_public_path__ + "boundaries-sample-960-a6c3e954e6e5663af7b31c43dc68630c.webp";